// AuthGuard.jsx — gate for authenticated routes. While the session probe is in
// flight → spinner; signed-out → redirect to /login; signed-in → render the
// routed page inside the AppShell chrome. Used as a LAYOUT ROUTE since SB-042
// (`<Route element={<AuthGuard/>}>…`): the guarded page arrives via <Outlet/>;
// explicit children still win when passed.
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../auth/AuthContext.jsx';
import AppShell from './AppShell.jsx';

export default function AuthGuard({ children, adminOnly = false }) {
  const { account, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!account) {
    return <Navigate to="/login" replace />;
  }

  // Admin-only routes (C6): non-admins are bounced home. The backend enforces the
  // real gate (is_admin on every /api/admin/* call); this is UX, not the boundary.
  if (adminOnly && !account.isAdmin) {
    return <Navigate to="/docs" replace />;
  }

  return <AppShell>{children ?? <Outlet />}</AppShell>;
}
